var OrganizationMixin;

export default OrganizationMixin = {
  methods: {
    _parseValueToEntries: function() {
      var _result, old_entry;
      _result = [];
      if (this.value) {
        if (this.entries.length && this.entries[0].id) {
          old_entry = _.clone(this.entries[0]);
          if (String(old_entry.value_id) !== String(this.value.id)) {
            old_entry._destroy = true;
          } else {
            old_entry._destroy = false;
          }
          _result.push(old_entry);
        }
        if (!(this.entries.length && this.entries[0].id && String(this.entries[0].value_id) === String(this.value.id))) {
          _result.push({
            value: this.value.name,
            field_id: this.field.id,
            value_id: this.value.id
          });
        }
      } else {
        if (this.entries.length && this.entries[0].id) {
          old_entry = _.clone(this.entries[0]);
          old_entry._destroy = true;
          _result.push(old_entry);
        }
      }
      return _result;
    },
    _initDefaultEntries: function(entries) {
      return entries[0] || {};
    },
    _parseEntriesToValue: function(entry) {
      // as a organization
      return this.value = entry.value ? {
        name: entry.value,
        id: entry.value_id
      } : null;
    }
  }
};
